module.exports = __webpack_public_path__ + "img/headerLogo.9924e7b0.png";